import { gql } from '@apollo/client';

export default gql`
  mutation CreateChildProducerMutation($childProducer: ChildProducerInput!) {
    createChildProducer(input: { childProducer: $childProducer }) {
      childProducer {
        groupId
        childProducerId
      }
    }
  }
`;
